module.exports = __webpack_public_path__ + "img/laboratorio4_4-3_2048.f09749cf.webp";